<template>
    <section class="c-login-content">
        <div class="card c-login-box">
            <h5 class="card-header bg-primary text-right text-white">{{$t('resetPassword')}}</h5>
            <div class="card-body">
                <form class="c-login-form" @submit="reset">
                    <div class="form-group mb-0 is-border-top">
                        <b-form-input class="form-control form-control-lg" type="password"
                                      :placeholder="$t('newPassword')" v-model="form.password"></b-form-input>
                    </div>
                    <div class="form-group is-border-bottom">
                        <b-form-input class="form-control form-control-lg" type="password"
                                      :placeholder="$t('rePassword')" v-model="form.rePassword"></b-form-input>
                    </div>
                    <div v-if="errors.length" class="alert alert-danger">
                        <span v-for="error in errors" :key="error.param">{{error.msg}}<br/></span>
                    </div>
                    <button class="btn btn-primary btn-lg btn-block is-border-circle" @click="reset">
                        {{$t('resetPassword')}}
                    </button>
                </form>
                <div class="c-login-more">
                    <p>{{$t('dontHaveAnAccount')}}</p>
                    <p><b><a href="#/register">{{$t('register')}}</a></b>
                        {{$t('or')}}
                        <b><a href="#/login">{{$t('login')}}</a></b>
                    </p>
                </div>
            </div>
        </div>
        <lang></lang>
    </section>
</template>

<script>
    import Lang from "../../components/Lang";

    export default {
        components: {Lang},
        props: ['token'],
        data: function () {
            return {
                form: {},
                errors: {}
            };
        },
        methods: {
            reset: function (evt) {
                evt.preventDefault();
                this.loading = true;
                this.form.token = this.token;
                this.errors = {};
                this.$service.post('/auth/reset', this.form).then(response => {
                    if (response.data) {
                        this.$swal({
                            text: this.$t('resetSuccess'),
                            icon: 'success'
                        }).then(() => {
                            location.href = '#/login';
                        });
                    } else {
                        this.$swal({
                            text: this.$t('resetFail'),
                            icon: 'error'
                        }).then(() => {
                            location.href = '#/forgot';
                        });
                    }
                }).catch(error => {
                    this.errors = error.response.data;
                }).finally(() => {
                    this.loading = false;
                });
            }
        }
    };
</script>